import React, { ReactElement } from 'react';
import Slider, { Settings } from 'react-slick';
import BreedArticleCard, { BreedArticleCardInterface } from '../card/breed-article-card';
import FANextArrow from '../slider/components/fa-next-arrow';
import FAPrevArrow from '../slider/components/fa-prev-arrow';

interface BreedArticlesProps {
  articles: BreedArticleCardInterface[];
}

const BreedArticles: React.FC<BreedArticlesProps> = ({ articles }): ReactElement => {
  const sliderSettings: Settings = {
    infinite: false,
    responsive: [
      {
        // Disable slider at screen widths above 991 px. Unfortunately, slick
        // only allows 'unslick' in ResponsiveObject, so the best way is to
        // set the breakpoint higher than any screen width. See:
        // https://stackoverflow.com/a/46214551
        breakpoint: 10000000,
        settings: articles.length > 2
          ? {
            slidesToShow: 2,
            centerMode: false,
            nextArrow: <FANextArrow />,
            prevArrow: <FAPrevArrow />,
          }
          : 'unslick',
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '60px',
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '30px',
        },
      },
    ],
  };

  return articles.length > 0 ? (
    <section className="breed-articles-section">
      <div className="breed-articles-container">
        <Slider {...sliderSettings}>
          {articles.map((article) => (
            <BreedArticleCard key={article.id} article={article} />
          ))}
        </Slider>
      </div>
    </section>
  ) : <></>;
};

export default BreedArticles;
